import { render, staticRenderFns } from "./PreDiagRecord.vue?vue&type=template&id=8a8c822e&scoped=true"
import script from "./PreDiagRecord.vue?vue&type=script&lang=js"
export * from "./PreDiagRecord.vue?vue&type=script&lang=js"
import style0 from "./PreDiagRecord.vue?vue&type=style&index=0&id=8a8c822e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8c822e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a8c822e')) {
      api.createRecord('8a8c822e', component.options)
    } else {
      api.reload('8a8c822e', component.options)
    }
    module.hot.accept("./PreDiagRecord.vue?vue&type=template&id=8a8c822e&scoped=true", function () {
      api.rerender('8a8c822e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/diagnosisRecord/PreDiagRecord.vue"
export default component.exports